module.exports = "/static/assets/fe5263e13c7d0dc4834ac8e648a88fbe.png";